// extracted by css-extract-rspack-plugin
export default {"root":"bwsoUE","discount-label":"h31lGh","discountLabel":"h31lGh","price":"aF1ola","old-price":"POuSZn","oldPrice":"POuSZn","exclusive":"xu6KUN"};